module.exports = __webpack_public_path__ + "img/logo.cecf5184.svg";